import CheckBadgeIcon from "@heroicons/react/24/outline/CheckBadgeIcon";

export default function ThanksScreen() {
  return (
    <div className="flex w-full h-[calc(100vh-450px)] max-h-[500px] min-h-[360px] justify-center items-center text-7xl text-[#15BBAE]">
      <CheckBadgeIcon className="size-14" />
    </div>
  );
}
